import { useSelector } from "react-redux";
import { RootState } from "../../store";

export const useBranchCode = () => {
  return useSelector(
    (state: RootState) => state.access.schoolBranch?.schoolBranchCode
  );
};
